

































import {Vue, Component} from 'vue-property-decorator';
import VLazyImage from 'v-lazy-image';
import {Title} from '@/components/Title';
import {PaymentTile} from '@/components/PaymentTile';
import {mapGetters, mapActions} from 'vuex';
import {setCookies} from '@/utils/cookies';

@Component({
  name: 'Payment',
  components: {
    Title,
    VLazyImage,
    PaymentTile,
  },
  props: {
    actualAmount: {
      type: Number,
      default: 0,
    },
    actualCard: {
      type: Object,
      default: {},
    },
    paymentInfo: {
      type: Object,
      default: {},
    },
    hasError: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      tokenData: null,
      payError: (this as any).hasError?.card || '' ,
      disablePayBtn: false,
    };
  },
  computed: {
    ...mapGetters(['paymentTexts']),
    ...mapGetters(['searchingPanelState', 'periodPickerData', 'actualSearchData']),
  },
  methods: {
    ...mapActions(['getTokenData', 'rentApartment', 'showCentralAlert']),
    srcImg(photo) {
      return photo && `${photo[3600]}` || '';
    },

    srcImgPlaceholder(photo) {
      return photo && `${photo[400]}`;
    },

    srcSet(photo) {
      return photo && `${photo[400]} 400w, ${photo[400]} 800w,
      ${photo[400]} 1300w, ${photo[800]} 1900w, ${photo[3600]} 3600w`;
    },

    changeCard() {
      this.getTokenData(`catalog/${this.$route.params.id}/`)
        .then((response) => {
          this.tokenData = response.form;
          this.$nextTick(() => (this.$refs.submitForm as HTMLElement).click());
        })
        .catch((error) => {
          console.error(error);
        });
    },

    payForApartment() {
      (this as any).disablePayBtn = true;
      const data = {
        id: this.$route.params.id,
        value: {
          start: this.searchingPanelState.startDate,
          end: this.$dayjs(this.searchingPanelState.startDate)
              .add(this.periodPickerData.value
                  ? this.periodPickerData.value
                  : this.periodPickerData.default, 'month')
              .format('YYYY-MM-DD'),
        },
      };
      this.rentApartment(data)
          .then((response) => {
            if (response.status === 200) {
              this.$gtm.trackEvent({
                eventCategory: 'rent_funnel',
                eventAction: 'click',
                eventLabel: 'payment_page',
                event: 'payment_page',
              });
              const ecomerce = response.data.additional_data;
              if (ecomerce) {
                this.$gtm.trackEvent({
                  transactionTotal: ecomerce.transactionTotal,
                  transactionTax: ecomerce.transactionTax,
                  transactionId: ecomerce.transactionId,
                  transactionProducts: {
                    sku: ecomerce.sku,
                    name: ecomerce.name,
                    category: ecomerce.category,
                    price: ecomerce.price,
                    quantity: ecomerce.quantity,
                  },
                });
                this.$emit('nextStep');
              } else {
                setCookies(this.$route.params.id, 'p2pPayment', 1);
                this.tokenData = response.data.form;
                this.$nextTick(() => (this.$refs.submitForm as HTMLElement).click());
              }
            } else if (response.status === 400 || response.status > 401) {
              (this as any).payError = response.data?.mobile_errors[0]?.messages[0];
            }
            (this as any).disablePayBtn = false;
          })
          .catch((error) => {
            console.log(error, 'error with payment');
          });
    },
  },
})
export default class Payment extends Vue {
}
